export default __webpack_public_path__ + "static/media/Tesla.af8f5745.gif";